import axios from 'axios';
import { useCallback, useState } from 'react';
import { Spinner } from 'react-bootstrap';
import Button from 'react-bootstrap/Button';
import Form from 'react-bootstrap/Form';
import Modal from 'react-bootstrap/Modal';
import { toast } from 'react-toastify';
import { v4 as uuidv4 } from 'uuid';
import { useUserAuth } from '../../context/UserAuthContext';

const PackageDeal = ({ item, dealCloseTrigger }) => {
    const packageId = item.id;
    const { token } = useUserAuth();
    const merchant_id = item.merchant_id;
    const base_url = import.meta.env.VITE_LOCAL_BASE_URL;
    const [data, setData] = useState({
        deal_close_price: '',
        payable_amount: 0,
        gst: 0,
        total_amount: 0,
        remark: ''

    })
    const [show, setShow] = useState(false);
    const handleClose = () => setShow(false);
    const handleShow = () => setShow(true);

    const handleDealCloseChange = (e) => {
        const { name, value } = e.target;

        if (name === 'deal_close_price') {
            const dealClosePrice = parseFloat(value) || 0;
            const payableAmount = (dealClosePrice * 5) / 100;
            const gstAmount = payableAmount * 0.18;
            const totalAmount = payableAmount + gstAmount;

            setData({
                deal_close_price: value,
                payable_amount: payableAmount,
                gst: gstAmount,
                total_amount: totalAmount,
                remark: `5% of deal close price (${dealClosePrice}) = ${payableAmount} + 18% GST = ${totalAmount}`
            });
        } else {
            setData(prev => ({
                ...prev,
                [name]: value
            }));
        }
    };


    const handleDealCloseSubmit = async (e) => {
        e.preventDefault();
        if (!data.deal_close_price) {
            toast.error('Please enter deal close price');
            return;
        }
        try {
            const res = await axios.put(`${base_url}/api/v1/deal-mgmt/package-enquiry/${packageId}`, data, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            })
            handleClose()
            dealCloseTrigger()
            toast.success('Update Your Deal Details')
        } catch (error) {
            console.log('eror', error.message)
        }
    };

    // pay  now code
    const [loading, setLoading] = useState({
        payment: false
    });
    const [currentPaymentStatus, setCurrentPaymentStatus] = useState(false);
    const [currentRequestId, setCurrentRequestId] = useState(null);
    const [showContactModal, setShowContactModal] = useState(false);
    const showContactDetails = (item) => {
        console.log(item)
        setCurrentRequestId(item.id);
        setCurrentPaymentStatus(item.deal_payment_status);
        setShowContactModal(true);
    };

    const processPayment = useCallback(async () => {
        if (!currentRequestId) {
            toast.error('No request selected for payment');
            return;
        }

        setLoading(prev => ({ ...prev, payment: true }));
        try {
            const orderId = uuidv4();
            const paymentReq = {
                order_id: orderId,
                amount: item.total_amount, // Convert to paise for Razorpay
                currency: "INR",
                payment_capture: 1
            };

            const result = await axios.post(`${base_url}/api/v1/razorpay/create`, paymentReq, {
                headers: {
                    Authorization: `Bearer ${token}`,
                }
            });
            const orderData = result?.data?.data;
            if (!orderData) {
                throw new Error('Payment initialization failed');
            }

            const options = {
                key: import.meta.env.VITE_RAZORPAY_KEY || "rzp_live_6XXCRghG3I98Mm",
                amount: orderData.amount,
                currency: orderData.currency,
                name: "Event Planet",
                description: "Venue Booking Payment",
                image: "https://eventplanet.in/assets/home/logo_main.png",
                order_id: orderData.id,
                handler: async (response) => {
                    try {
                        await Promise.all([
                            axios.post(`${base_url}/api/v1/transaction`, {
                                merchant_id,
                                transactionType: 'credit',
                                transaction_id: response?.razorpay_payment_id,
                                amount: item.total_amount,
                                info: {
                                    base_price: item.payable_amount,
                                    cgst: item.gst / 2,
                                    sgst: item.gst / 2,
                                    sub_total: item.total_amount,
                                    discount: 0,
                                    grand_total: item.total_amount
                                },
                            }, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                }
                            }),
                            axios.post(`${base_url}/api/v1/packages/payment/deal/status`, {
                                id: currentRequestId
                            }, {
                                headers: {
                                    Authorization: `Bearer ${token}`,
                                }
                            })
                        ]);

                        setCurrentPaymentStatus(true);
                        toast.success('Payment successful!');
                    } catch (error) {
                        console.error('Payment processing error:', error);
                        toast.error('Error processing payment');
                    }
                },
                theme: { color: "#3399cc" },
                prefill: {
                    name: '',
                    email: '',
                    contact: ''
                },
                modal: {
                    ondismiss: () => {
                        toast.info('Payment window closed');
                    }
                }
            };

            const paymentObj = new window.Razorpay(options);
            paymentObj.open();
        } catch (error) {
            toast.error(`Payment error: ${error.message}`);
        } finally {
            setLoading(prev => ({ ...prev, payment: false }));
        }
    }, [base_url, currentRequestId]);


    const PaymentBreakdown = ({ leadAmount, cgst, sgst, discountAmount, grandTotal }) => (
        <div className="payment-breakdown">
            <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">Base Price:</span>
                <span>₹{leadAmount?.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">CGST (9%):</span>
                <span>₹{cgst.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between mb-2">
                <span className="text-muted">SGST (9%):</span>
                <span>₹{sgst.toFixed(2)}</span>
            </div>
            <div className="d-flex justify-content-between mb-2 border-bottom pb-2">
                <span className="text-muted">Sub Amount:</span>
                <span>₹{(leadAmount + cgst + sgst).toFixed(2)}</span>
            </div>
            {discountAmount > 0 && (
                <div className="d-flex justify-content-between mb-2 text-success">
                    <span>Discount Amount:</span>
                    <span>-₹{discountAmount.toFixed(2)}</span>
                </div>
            )}
            <div className="d-flex justify-content-between mt-3 fw-bold fs-5">
                <span>Grand Total:</span>
                <span>₹{grandTotal.toFixed(2)}</span>
            </div>
        </div>
    );

    const closeContactModal = () => {
        setShowContactModal(false);
        setCurrentRequestId(null);
    };
    return (
        <>
            {
                (item.deal_status == "pending" || item.deal_status == "close") ? (
                    <Button
                        variant={item.deal_status == "close" ? "outline-success" : "outline-primary"}
                        size="sm"
                        onClick={() => showContactDetails(item)}
                        disabled={item.deal_payment_status || loading.payment || currentPaymentStatus}
                    >
                        {(item.deal_status == "close" || currentPaymentStatus) ? 'Deal Closed' : 'Pay Now'}
                        {loading.payment && <Spinner animation="border" size="sm" className="ms-2" />}
                    </Button>
                ) :
                    (
                        <Button variant="primary" onClick={handleShow}>
                            Deal Closed At
                        </Button>
                    )
            }
            <Modal show={show} onHide={handleClose}>
                <Modal.Header closeButton>
                    <Modal.Title>Modal heading</Modal.Title>
                </Modal.Header>
                <Form onSubmit={handleDealCloseSubmit}>
                    <Modal.Body>
                        <Form.Group className="mb-3">
                            <Form.Label>Deal Close Price (₹)</Form.Label>
                            <Form.Control
                                type="number"
                                name="deal_close_price"
                                value={data.deal_close_price}
                                onChange={handleDealCloseChange}
                                placeholder="Enter deal close price"
                                required
                            />
                        </Form.Group>

                        <div className="payment-breakdown">
                            <p className="payment-item">
                                <span className='payment-label'>Payable Amount (5% of deal close price):</span>
                                <span className='payment-value'>₹{data.payable_amount.toFixed(2)}</span>
                            </p>
                            <p className="payment-item">
                                <span className='payment-label'>GST (18% on payable amount):</span>
                                <span className='payment-value'>₹{data.gst.toFixed(2)}</span>
                            </p>
                            <hr />
                            <p className="payment-item total">
                                <span className='payment-label'>Total Amount:</span>
                                <span className='payment-value'>₹{data.total_amount.toFixed(2)}</span>
                            </p>
                        </div>

                        <Form.Group classNam e="mb-3">
                            <Form.Label>Remark</Form.Label>
                            <Form.Control
                                as="textarea"
                                rows={3}
                                name="remark"
                                value={data.remark}
                                onChange={handleDealCloseChange}
                                placeholder="Enter any remarks"
                            />
                        </Form.Group>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleClose}>
                            Cancel
                        </Button>
                        <Button
                            variant="success"
                            type="submit"
                            disabled={!data.deal_close_price}
                        >
                            Submit
                        </Button>
                    </Modal.Footer>
                </Form>
            </Modal>

            <Modal show={showContactModal} onHide={closeContactModal} backdrop="static" centered dialogClassName="modal-90w"
                aria-labelledby="example-custom-modal-styling-title">
                <Modal.Header closeButton>
                    <Modal.Title>Deal Details</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className="row">
                        {!currentPaymentStatus && (
                            <div className="col-md-12">
                                <div className="payment-section p-3 border rounded">
                                    <h5>Payment Details</h5>
                                    <PaymentBreakdown
                                        leadAmount={item.payable_amount}
                                        cgst={item.gst / 2}
                                        sgst={item.gst / 2}
                                        discountAmount={0}
                                        grandTotal={item.total_amount}
                                    />
                                </div>
                            </div>
                        )}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    {!currentPaymentStatus ? (
                        <Button
                            variant="success text-white"
                            onClick={processPayment}
                            disabled={loading.payment}
                            className="d-flex align-items-center"
                        >
                            {loading.payment ? (
                                <>
                                    <Spinner animation="border" size="sm" className="me-2" />
                                    Processing...
                                </>
                            ) : (
                                `Pay ₹${item?.total_amount?.toFixed(2)}`
                            )}
                        </Button>
                    ) : (
                        <Button variant="secondary" onClick={closeContactModal}>
                            Close
                        </Button>
                    )}
                </Modal.Footer>
            </Modal>
        </>
    )
}

export default PackageDeal